/* src/app/shared-module/components/skeleton-components/skeleton-property/skeleton-property.component.scss */
.card-builder-properties {
  border-radius: 20px;
  padding: 2px;
  box-shadow: none;
  background-color: white;
}
/*# sourceMappingURL=skeleton-property.component.css.map */
